import { get } from 'lodash';

export const formatAddress = eventLocation => {
  const address = get(eventLocation, 'address')
  let formattedAddress = '';

  if (eventLocation.name) formattedAddress += `${eventLocation.name}, `
  if (address.streetAddress) formattedAddress += `${address.streetAddress}, `
  if (address.city) formattedAddress += `${address.city}, `
  if (address.state) formattedAddress += `${address.state}`

  return formattedAddress;
}